export default __webpack_public_path__ + "static/media/searching-someone.55bde3f7.svg";